import { render, staticRenderFns } from "./SecaoConfEcac.vue?vue&type=template&id=edf7206c&"
import script from "./SecaoConfEcac.vue?vue&type=script&lang=js&"
export * from "./SecaoConfEcac.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports